<template>
  <div class="animated fadeIn">
    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <b-form-checkbox
              @input="updateContact(data.item)"
              v-model="data.item.Include"
            ></b-form-checkbox>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "ContactList",
  data: () => {
    return {
      fields: [
        {
          key: "Vendor.Name",
          label: "Company",
          sortable: true
        },
        {
          key: "Name",
          label: "Name",
          sortable: true
        },
        { key: "Phone1", label: "Phone", sortable: true, thStyle: "width:10%" },
        { key: "Email", label: "Email", sortable: true },
        {
          key: "Functions",
          label: "Include",
          sortable: false,
          thStyle: "width: 5%;"
        }
      ],
      mySelected: { Vendor: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  props: {
    VendorID: -1
  },
  created() {
    //this.$store.dispatch("seminar/fetchVendors").then();
    this.$store.dispatch("seminar/fetchContacts").then(this.filterList());
    //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.contacts.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.contacts;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      this.filterList();
    }
  },
  methods: {
    filterList: function() {
      this.filteredObjects = this.$store.state.seminar.contacts.filter(
        contact =>
          contact.VendorID ===
            this.$store.state.seminar.seminar_edit.VendorID ||
          contact.VendorID === -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadContactEdit", record.ContactID)
        .then(() => {
          this.$router.push({ name: "Contact" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("seminar/newContact", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Contact" });
          //,
          //params: { id: this.event.id }
        })
        .catch(error => {
          console.log(error.message);
          //.dispatch('notification/add', this.event)
        });
    },
    createFreshObject() {
      return {
        ContactID: -1,
        VendorID: this.$store.state.seminar.vendor_edit.VendorID
      };
    },
    async updateContact(object) {
      this.$store.state.saveOp.localUrl = "/Seminar/SaveContact/";
      this.$store.state.saveOp.localVariableName = "_c";
      this.$store.state.saveOp.localVariableObject = object;
      this.$store.state.saveOp.localFieldToSet = "ContactID";
      this.$store.state.saveOp.localReturnObject = "SaveContactResult";
      this.$store.state.saveOp.localDirtyFields = [
        {
          FieldName: "Include",
          FieldValue: object.Include.toString()
        }
      ];
      await this.$store.dispatch("saveOp/BuildSaveOperation");
      await this.$store.dispatch("saveOp/EmitSave");
      this.$store.state.saveOp.localDirtyFields = [];
      this.$store.state.saveOp.DestroySaveOperation;
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
